import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@agissc/ktag-map';
import { useDebouncedState } from '../../utils/useDebouncedState';

interface LayerVisibilityProps {
  onToggleVisibility: () => void;
  isVisible: boolean;
  onOpacityChanged: (value: number) => void;
  opacity: number;
  additionalClassNames?: string;
  disabled?: boolean;
}

const LayerVisibility = ({
  onToggleVisibility,
  isVisible,
  onOpacityChanged,
  opacity,
  additionalClassNames,
  disabled = false,
}: LayerVisibilityProps) => {
  const { t } = useTranslation('agisviewer');
  const [opacityDebounced, setOpacityDebounced] = useDebouncedState(
    opacity,
    onOpacityChanged,
  );

  return (
    <div
      className={classNames('visiblity-settings', additionalClassNames, {
        disabled,
      })}
    >
      <IconButton
        onClick={onToggleVisibility}
        icon={isVisible ? 'eye-opened' : 'eye-closed'}
        title={isVisible ? t('topic_visible') : t('topic_invisible')}
        disabled={disabled}
      />
      <div className="opacity-slider">
        <input
          className="opacity-slider__input"
          type="range"
          min={0}
          max={1}
          step={0.05}
          onChange={(e) => setOpacityDebounced(parseFloat(e.target.value))}
          value={opacityDebounced}
          title={t('topic_edit_transparency')}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default LayerVisibility;
